import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import './MerchantOffer.scss';

export function MerchantOffer({ offer }) {
  const {
    description, isOngoing, expires, code, clickUrl, disclaimer, merchant, isFeatured,
  } = offer;

  const [isCopyBalloonVisible, setIsCopyBalloonVisible] = useState(false);
  const baloonHideTimeout = useRef();

  const handleCopyBtn = () => {
    if (!isCopyBalloonVisible) {
      clearTimeout(baloonHideTimeout.current);
      setIsCopyBalloonVisible(true);
      baloonHideTimeout.current = setTimeout(() => {
        setIsCopyBalloonVisible(false);
      }, 300);
    }
  };

  if (!description || !clickUrl || !merchant) {
    return null;
  }

  return (
    <div className={`mn_merchantExperienceOffer ${isFeatured ? 'mn_featuredOffer' : ''}`} data-test="merchant-offer">
      {
        isFeatured &&
        <div className="mn_ribbon" data-test="merchant-offer-ribbon">
          <span>Featured offer</span>
        </div>
      }
      <div className="mn_description">
        <p className="mn_descriptionText" data-test="merchant-offer-description-text">
          {description}
          {' '}
          <span className="mn_expire" data-test="merchant-offer-expire">
            {isOngoing ? <>Ongoing</> : <>Valid thru: {expires}</>}
          </span>
        </p>
        {code && (
          <p className="mn_couponCode" data-test="merchant-offer-coupon-code">
            Use code:&nbsp;
            <CopyToClipboard text={code}>
              <button
                className="mn_copyCouponCode mn_balloonTooltip mn_showOnHover"
                data-balloon="Copied"
                data-balloon-pos="up"
                {...(isCopyBalloonVisible ? { 'data-balloon-visible': true } : {})}
                onClick={() => handleCopyBtn()}
              >
                {code}
              </button>
            </CopyToClipboard>
          </p>
        )}
        {disclaimer && <p className="mn_disclaimer" data-test="merchant-offer-disclaimer">{disclaimer}</p>}
      </div>
      <div className="mn_offerShopNow">
        <a
          href={clickUrl}
          className={`mn_button mn_secondaryButton ${isFeatured ? 'mn_shopFeaturedOfferButton' : 'mn_shopOfferButton'}`}
          data-merchant-name={merchant.name}
          title={`Opens a new window at ${merchant.name}`}
          target="_blank"
          data-test="merchant-offer-shop-now-link"
        >
          Shop this offer
        </a>
      </div>
    </div>
  );
}

MerchantOffer.propTypes = {
  offer: PropTypes.shape({}).isRequired,
};

export default MerchantOffer;
